import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ProductListTab from './productsTab/products/ProductsListTab';
import FormListTab from './productsTab/forms/FormListTab';
import { useTranslation } from 'react-i18next';
import {
    FORM_TAB_NAME,
    ITEM_TAB_NAME,
    PAGE_TAB_NAME_COMPOSITION_TREE,
    PAGE_TAB_NAME_LIST,
    PRODUCT_TAB,
    PROPERTY_TAB_NAME,
} from '../constant';
import PropertyListTab from './productsTab/properties/PropertiesListTab';
import PropertyCompositionTreeTab from './productsTab/properties/PropertyCompositionTreeTab';
import { ErrorHandler } from './ErrorHandler';
import EditProductTab from './productsTab/products/EditProductTab';
import EditFormTab from './productsTab/forms/EditFormTab';
import EditPropertyTab from './productsTab/properties/EditPropertyTab';
import Title from './Title';
import NavigationTabs from '../shared/NavigationTabs';
import { productPageNavigationService } from '../services/productPageNavigationService';

const ProductPage = () => {
    const [activeRoute, setActiveRoute] = useState('');
    const {tab, id} = useParams();
    const { i18n } = useTranslation();
    const showProductChrome = id === PAGE_TAB_NAME_LIST || id === PAGE_TAB_NAME_COMPOSITION_TREE;

    useEffect(() => {
        setActiveRoute(`/${PRODUCT_TAB}/${tab}/${id}/`);
    }, [tab, id]);

    try {
        if(!activeRoute) return null;
        return (
            <section className="workspace workspace__product">
                {showProductChrome ? (
                    <>
                        <Title titleValue={i18n.t('app.page.product.title')}/>
                        <NavigationTabs navigationService={productPageNavigationService} />
                    </>
                ) : null}
                {tab === ITEM_TAB_NAME ? 
                    id === PAGE_TAB_NAME_LIST ?
                        <ProductListTab />
                        :
                        <EditProductTab /> 
                    : null}
                {tab === FORM_TAB_NAME ? 
                    id === PAGE_TAB_NAME_LIST ?
                        <FormListTab /> 
                        :
                        <EditFormTab />
                    : null}
                {tab === PROPERTY_TAB_NAME ? (
                    id === PAGE_TAB_NAME_LIST ? (
                        <PropertyListTab />
                    ) : id === PAGE_TAB_NAME_COMPOSITION_TREE ? (
                        <PropertyCompositionTreeTab />
                    ) : (
                        <EditPropertyTab />
                    )
                ) : null}
            </section>
        );
    } catch (err) {
        console.log(err);
        return <ErrorHandler titleValue={i18n.t('app.page.profile.emptyData')}/>;
    }
};

export default ProductPage;
